const accessToken =
  "Bearer " + JSON.parse(window.localStorage.getItem('authUser'))?.data?.accessToken
export default accessToken
